import { Set } from '@everyboard/lib';
import { MoveGenerator } from '../../jscaip/AI/AI';
import { Coord } from '../../jscaip/Coord';
import { FourStatePiece } from '../../jscaip/FourStatePiece';
import { TableUtils } from '../../jscaip/TableUtils';
import { FourStatePieceGameStateWithTable } from '../../jscaip/state/FourStatePieceGameStateWithTable';
import { HexodiaMove } from './HexodiaMove';
export class HexodiaMoveGenerator extends MoveGenerator {
    getListMoves(node, _config) {
        if (node.gameState.turn === 0) {
            return this.getFirstMove(node.gameState);
        }
        else {
            return this.getListDrops(node);
        }
    }
    getFirstMove(state) {
        const width = state.getWidth();
        const height = state.getHeight();
        const cx = Math.floor(width / 2);
        const cy = Math.floor(height / 2);
        const center = new Coord(cx, cy);
        return [
            HexodiaMove.of([center]),
        ];
    }
    getListDrops(node) {
        const availableFirstCoords = this.getAvailableCoords(node.gameState);
        const moves = [];
        for (const firstCoord of availableFirstCoords) {
            const board = node.gameState.getCopiedBoard();
            board[firstCoord.y][firstCoord.x] = FourStatePiece.ofPlayer(node.gameState.getCurrentPlayer());
            const stateAfterFirstDrops = new FourStatePieceGameStateWithTable(board, node.gameState.turn);
            const availableSecondCoords = this.getAvailableCoords(stateAfterFirstDrops);
            for (const secondCoord of availableSecondCoords) {
                const newMove = HexodiaMove.of([firstCoord, secondCoord]);
                moves.push(newMove);
            }
        }
        return new Set(moves).toList(); // Removes duplicates
    }
    getAvailableCoords(state) {
        const usefulCoordTable = this.getUsefulCoordsTable(state);
        const availableCoords = [];
        for (const coordAndContent of state.getCoordsAndContents()) {
            const coord = coordAndContent.coord;
            if (usefulCoordTable[coord.y][coord.x] && coordAndContent.content === FourStatePiece.EMPTY) {
                availableCoords.push(coord);
            }
        }
        return availableCoords;
    }
    /**
     * This function returns a table on which table[y][x] is true only if:
     *     (x, y) is empty but has occupied neighbors
     */
    getUsefulCoordsTable(state) {
        const width = state.getWidth();
        const height = state.getHeight();
        const usefulCoordTable = TableUtils.create(width, height, false);
        for (const coordAndContent of state.getPlayerCoordsAndContent()) {
            this.addNeighboringCoord(usefulCoordTable, coordAndContent.coord);
        }
        return usefulCoordTable;
    }
    /**
     * mark the space neighboring coord as "space that have an occupied neighbor"
     * @param usefulCoordTable a map of the board which each space mapped to true if it has an occupied neighbor
     * @param coord the coord to add to this map
     */
    addNeighboringCoord(usefulCoordTable, coord) {
        const maxPossibleX = usefulCoordTable[0].length - 1;
        const maxPossibleY = usefulCoordTable.length - 1;
        //  The magical value  "1" after this line is used to make the generator only include neighboring coord
        // Modifying it to 2 could make it include furter moves
        const minX = Math.max(0, coord.x - 1);
        const minY = Math.max(0, coord.y - 1);
        const maxX = Math.min(maxPossibleX, coord.x + 1);
        const maxY = Math.min(maxPossibleY, coord.y + 1);
        for (let y = minY; y <= maxY; y++) {
            for (let x = minX; x <= maxX; x++) {
                usefulCoordTable[y][x] = true;
            }
        }
    }
}
